import { defineCustomElement } from 'vue';
import MarketCarpetElement from '@/components/MarketCarpetElement.ce.vue';
import { version } from '@/ts/constants/version';

// Convert Vue component to Custom Element
const MarketCarpetCE = defineCustomElement(MarketCarpetElement);

// Register the custom element with a given tag name
export function register(tagName = 'market-carpet') {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, MarketCarpetCE);
  }
}

// Auto-register with default name when this module is imported
register();

console.log(`MarketCarpet v${version} loaded`);

// Export for consumers who want manual control
export { MarketCarpetCE };

// Export types for TypeScript consumers
export type {
  MarketCarpetContext,
  MarketCarpetContextOptions,
} from '@/ts/marketCarpetContext';

export type { LeafNode, ParentNode } from '@/ts/composables/useMarketCarpetData';
export type { LeafBoxHoverData, ParentBoxHoverData } from '@/ts/composables/useHoverBox';
export type { CalculatorKey } from '@/ts/composables/useCalculator';
export type { ColorSchemeKey } from '@/ts/composables/useColorScheme';
export type { SizeByKey } from '@/ts/composables/useSizeBy';

export { DEFAULT_PERIOD } from '@/ts/composables/usePeriod';
export { DEFAULT_CALCULATOR } from '@/ts/composables/useCalculator';
export { DEFAULT_COLOR_SCHEME } from '@/ts/composables/useColorScheme';
export { DEFAULT_SIZE_BY } from '@/ts/composables/useSizeBy';
export { DEFAULT_SHOW_SYMBOLS } from '@/ts/composables/useShowSymbols';
export { DEFAULT_AUTO_REFRESH } from '@/ts/composables/useMarketCarpetData';
